import { AdFoxBanner } from '@/packages/adfox/AdfoxBanner';
import { AdfoxContextProvider, type AdfoxContextProviderProps } from '@/packages/adfox/AdfoxContext';
import { useSearchOffersDesktopQuery } from '@/packages/query-state/shared/store/search-offers/v3/search-offers-desktop/query';
import { memoWithDisplayName } from '@/packages/react-utils/memoWithDisplayName';

import styles from './AdfoxParallaxBottomBanner.css';

const POST_VIEW_ANALYTICS_DATA: AdfoxContextProviderProps['postViewAnalyticsData'] = {
  place: 'footer',
  place__DEPRECATED: 'footerSerp',
  name__DEPRECATED: 'Listing_parallax',
};
const P_PARAMS: AdfoxContextProviderProps['pParams'] = { p1: 'dbtyp', p2: 'y' };
const SIZE: AdfoxContextProviderProps['size'] = { width: '100%', height: 560 };

export const AdfoxParallaxBottomBanner = memoWithDisplayName(() => {
  const { data } = useSearchOffersDesktopQuery({
    notifyOnChangeProps: ['data'],
  });

  const adfox = data?.pages[0].adfox;

  if (!adfox) {
    return null;
  }

  return (
    <div className={styles['container']}>
      <AdfoxContextProvider
        pParams={P_PARAMS}
        postViewAnalyticsData={POST_VIEW_ANALYTICS_DATA}
        serverData={adfox}
        size={SIZE}
      >
        <AdFoxBanner />
      </AdfoxContextProvider>
    </div>
  );
}, 'AdfoxParallaxBottomBanner');
